import React from 'react'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'

export type CheckboxInputProps = {
  /**
   * If true, the component is checked
   */
  checked?: boolean
  disabled?: boolean
  /**
   * The label content
   */
  label?: string
  name?: string
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  readOnly?: boolean
  /**
   * The value of the component
   */
  value?: string
  /**
   * The id of the `input` element.
   */
  id?: string
}

export default function CheckboxInput(props: CheckboxInputProps) {
  const { checked, disabled, label, name, onChange, readOnly = false, value, id } = props

  return (
    <FormControlLabel
      control={<Checkbox id={id} checked={checked} disabled={disabled} onChange={!readOnly ? onChange : undefined} />}
      label={label || ''}
      name={name}
      value={value}
    />
  )
}